import { findAll, advanceBalance, undoAdvanceBalance } from '../../services/recharge/rechargeServiceAdmin'

const state = {
  rechargesAdmin: [],
}

const getters = {
  rechargesAdmin: (state) => state.rechargesAdmin,
}

const actions = {
  async fetchRechargesAdmin({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await findAll(params)
      const { result, total } = await data

      commit('setRechargesAdmin', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async advanceBalance({commit, dispatch}, rechargeId) {
    commit('setIsLoadingButton', true)

    advanceBalance(rechargeId)
      .then(() => {
        dispatch('fetchRechargesAdmin')
        commit('closeAllModals')
        dispatch('showSuccessMessage', 'Saldo adiantado com sucesso!')
      })
      .catch(({ data }) => {
        dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoadingButton', false))
  },

  async undoAdvanceBalance({commit, dispatch}, rechargeId) {
    commit('setIsLoadingButton', true)

    undoAdvanceBalance(rechargeId)
      .then(() => {
        dispatch('fetchRechargesAdmin')
        commit('closeAllModals')
        dispatch('showSuccessMessage', 'Adiantamento de saldo desfeito com sucesso!')
      })
      .catch(({ data }) => {
        dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoadingButton', false))
  }
}

const mutations = {
  setRechargesAdmin: (state, rechargesAdmin) => {
    state.rechargesAdmin = rechargesAdmin
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
